import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { radarPoints, selfCheckItems } from '@/mocks/homeData';

function levelStyle(level: string) {
  if (level === '高频') {
    return 'bg-primary-100 text-primary-700';
  }
  if (level === '中频') {
    return 'bg-accent-100 text-accent-800';
  }
  return 'bg-secondary-100 text-secondary-900';
}

export default function RadarGuide() {
  const [checked, setChecked] = useState<boolean[]>(() => selfCheckItems.map(() => false));
  const doneCount = checked.filter(Boolean).length;

  const toggle = (index: number) => {
    setChecked((prev) => prev.map((value, i) => (i === index ? !value : value)));
  };

  const progress = Math.round((doneCount / selfCheckItems.length) * 100);

  return (
    <section id="radar" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="分区 05 · 避雷自查"
          title="路人反感点分析：判断一个人值不值得追"
          desc="与其记住一长串名单，不如记住几个反复出现的信号。下面这些反感点，是讨论中被提到次数最多的类型。"
          actionLabel="查看名单"
          actionHref="#blacklist"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr] lg:gap-10">
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {radarPoints.map((point) => (
              <li
                key={point.title}
                className="rounded-lg border border-foreground-200/80 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between gap-3">
                  <h4 className="font-heading text-base font-bold text-foreground-950">
                    {point.title}
                  </h4>
                  <span
                    className={`shrink-0 rounded-full px-2.5 py-1 font-label text-[11px] ${levelStyle(
                      point.level,
                    )}`}
                  >
                    {point.level}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </li>
            ))}
          </ul>

          <div className="flex flex-col rounded-lg border border-foreground-200/80 bg-background-50 p-5 md:p-6">
            <div className="flex items-end justify-between gap-4">
              <div>
                <span className="font-label text-[11px] tracking-[0.28em] text-primary-600">
                  自查清单
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                  转发之前，先问自己五个问题
                </h3>
              </div>
              <span className="shrink-0 font-heading text-2xl font-bold text-primary-500">
                {progress}%
              </span>
            </div>

            <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div
                className="h-full rounded-full bg-primary-500 transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>

            <ul className="mt-5 flex flex-col divide-y divide-foreground-200/70">
              {selfCheckItems.map((item, index) => (
                <li key={item}>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    className="flex w-full items-start gap-3 py-3 text-left"
                  >
                    <span
                      className={
                        checked[index]
                          ? 'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50'
                          : 'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-foreground-300 text-transparent'
                      }
                    >
                      <i className="ri-check-line text-xs" />
                    </span>
                    <span
                      className={
                        checked[index]
                          ? 'font-label text-[13px] leading-relaxed text-foreground-500 line-through'
                          : 'font-label text-[13px] leading-relaxed text-foreground-800'
                      }
                    >
                      {item}
                    </span>
                  </button>
                </li>
              ))}
            </ul>

            <p className="mt-4 font-label text-[12px] leading-relaxed text-foreground-500">
              清单不会提交到任何地方，仅帮助你在这台设备上理一理自己的判断。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}